var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('d-button',{on:{"click":function($event){_vm.show = !_vm.show}}},[_vm._v("显示")]),_c('m-popup',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',[_vm._v("22222222")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }